import * as configData from 'src/assets/Auth-Config.json';
 
export const CdsConfigData = configData;